// This file handls timezone stuff with dayjs
// and sets the default timezone for the application.
// It also exports the dayjs instance for use in other files.
import dayjsLib from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjsLib.extend(utc);
dayjsLib.extend(timezone);
dayjsLib.extend(customParseFormat);

let isTimezoneSet = false;

export const setDefaultTimezone = (tz: string) => {
    console.log('Setting default timezone to:', tz);
  if (!isTimezoneSet) {
    dayjsLib.tz.setDefault(tz);
    isTimezoneSet = true;
  }
};

export const dayjs = dayjsLib;
export type { Dayjs } from 'dayjs';
